import { Input, Checkbox, Button } from "@material-tailwind/react";
import React, { useState } from 'react';
import { useUser } from '@clerk/clerk-react';

export default function CreateTagGroupModal({ onClose, onCreateGroup, onSave, isEdit = false, initialName = '', initialTags = [], initialMatchAll = false }) {
  const [name, setName] = useState(initialName);
  const [tags, setTags] = useState(initialTags.join(', '));
  const [matchAll, setMatchAll] = useState(initialMatchAll);

  const { user } = useUser();

  const handleSubmit = () => {
    const tagArray = tags
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(t => t.length > 0);

    if (!name.trim() || tagArray.length === 0) return;

    const groupData = { name, tags: tagArray, matchAll, userId: user.id };

    if (isEdit && onSave) {
      onSave(groupData);
    } else {
      onCreateGroup(groupData);
    }

    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">{isEdit ? 'Edit Tag Group' : 'Add Tag Group'}</h2>
        <div className="mb-2">
          <Input
            label="Group Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            crossOrigin=""
            variant="standard"
          />
        </div>
        <div className="mb-2">
          <Input
            label="Tags (comma-separated)"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            crossOrigin=""
            variant="standard"
          />
        </div>
        <div className="mb-4">
          <Checkbox
            label="Match all tags (AND)"
            checked={matchAll}
            onChange={(e) => setMatchAll(e.target.checked)}
            crossOrigin=""
          />
        </div>
        <div className="flex justify-end space-x-2">
          <Button variant="text" onClick={onClose} color="blue">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="blue">
            {isEdit ? 'Save Changes' : 'Create'}
          </Button>
        </div>
      </div>
    </div>
  );
}